export default {
  data() {
    return {
      roundMenuItems: [],
    };
  },
  created() {
    this.roundMenuItems = [
      {
        key: 'force-start-all',
        title: 'Start all',
        handler: this.confirmStartRound,
        disabled: false,
      },
      {
        key: 'force-finish-all',
        title: 'Finish all',
        handler: this.confirmFinishRound,
        disabled: false,
      },
      {
        key: 'round-chat-win',
        title: 'Chat with winners',
        handler: this.openChat,
        defaultOptions: {
          conversationType: 'group_chat',
          targetGroup: 'Winners',
        },
        disabled: false,
      },
      {
        key: 'round-chat-lose',
        title: 'Chat with loosers',
        handler: this.openChat,
        defaultOptions: {
          conversationType: 'group_chat',
          targetGroup: 'Losers',
        },
        disabled: false,
      },
      {
        key: 'round-chat-all',
        title: 'Chat with all',
        handler: this.openChat,
        defaultOptions: {
          conversationType: 'group_chat',
          targetGroup: 'All',
        },
        disabled: false,
      },
      {
        key: 'round-channel-win',
        title: 'Channel with winners',
        handler: this.openChat,
        defaultOptions: {
          conversationType: 'channel',
          targetGroup: 'Winners',
        },
        disabled: false,
      },
      {
        key: 'round-channel-lose',
        title: 'Channel with eliminated',
        handler: this.openChat,
        defaultOptions: {
          conversationType: 'channel',
          targetGroup: 'Losers',
        },
        disabled: false,
      },
      {
        key: 'round-channel-all',
        title: 'Channel with all',
        handler: this.openChat,
        defaultOptions: {
          conversationType: 'channel',
          targetGroup: 'All',
        },
        disabled: false,
      },
    ];
  },
  methods: {
    getRoundMenuItems(items = []) {
      return this.roundMenuItems.filter(item => {
        return items.includes(item.key);
      });
    },
  },
};
